import { Stack, Text } from "@leabankab/component-library";

type StepHeaderColor = "tertiary" | "primary";

const ICON_CLASSES: Record<StepHeaderColor, string> = {
	tertiary: "bg-tertiary-subtle text-teal-600",
	primary: "bg-primary-subtle text-purple-600",
};

interface StepHeaderProps {
	title?: string;
	children?: React.ReactNode;
	icon?: React.ReactNode;
	color?: StepHeaderColor;
	/** Heading level. Defaults to `h2`; `StepShell` owns the step's `h1`. */
	as?: "h1" | "h2";
	/** Horizontal alignment of the header content. Defaults to `center`. */
	align?: "center" | "left";
}

export const StepHeader = ({
	title,
	children,
	icon,
	color = "tertiary",
	as = "h2",
	align = "center",
}: StepHeaderProps) => {
	const isCentered = align === "center";
	const alignItems = isCentered ? "center" : "start";
	const textAlign = isCentered ? "text-center" : "text-left";
	const Heading = as;

	return (
		<Stack gap={1.5} align={alignItems} className={textAlign}>
			{icon && (
				<div
					aria-hidden="true"
					className={`flex items-center justify-center rounded-full p-2 ${isCentered ? "self-center" : "self-start"} ${ICON_CLASSES[color]}`}
				>
					{icon}
				</div>
			)}
			<Stack gap={0.5} align={alignItems} className={textAlign}>
				<Text
					render={<Heading />}
					textStyle={as === "h1" ? "heading-md" : "heading-sm"}
				>
					{title}
				</Text>
				{children}
			</Stack>
		</Stack>
	);
};
